import one from "../../assets/1.mp3";
import eat from "../../assets/eat.mp3";
import handleDhamaMoves from "../dhamaMoves/handleDhamaMoves";
import EatMore from "../eatMore/eatMore";
import changeFromPawnToDhama from "../dhamaMoves/changeFromPawnToDhama";
import checkMustEat from "../mustEat/checkMustEat";
import {
  R1,
  L1,
  R1L3,
  R1L2R1,
  R1L1R1L1,
  R1L1R2,
  R4,
  R3L1,
  R2L2,
  R2L1R1,
  L1R3,
  L1R2L1,
  L1R1L1R1,
  L1R1L2,
  L4,
  L3R1,
  L2R2,
  L2R1L1,
} from "../playersMoves/playerTwoMovesLogic";
import {
  R1_P1,
  L1_P1,
  R1L3_P1,
  R1L2R1_P1,
  R1L1R1L1_P1,
  R1L1R2_P1,
  R4_P1,
  R3L1_P1,
  R2L2_P1,
  R2L1R1_P1,
  L1R3_P1,
  L1R2L1_P1,
  L1R1L1R1_P1,
  L1R1L2_P1,
  L4_P1,
  L3R1_P1,
  L2R2_P1,
  L2R1L1_P1,
} from "../playersMoves/playerOneMovesLogic";
export function handleSquareClick(
  boardDataRef,
  i,
  j,
  squareRef,
  squareRefPawns,
  boardData,
  setBoardData,
  playerTurn,
  prevSquare,
  setPrevSquare,
  setPlayerTurn,
  x,
  dhamaIndex,
  pawnsInTouch,
  activeSound
) {
  const clickedSquareData = boardData.find(
    (square) => square[1] === i && square[2] === j
  );
  const [squareColor, row, col] = clickedSquareData;
  if (prevSquare !== null) {
    const [prevRow, prevCol] = prevSquare;
    const prevSquareIndex = prevRow * 10 + prevCol;
    const currentSquareIndex = row * 10 + col;
    squareRef.current[prevSquareIndex].classList.remove("gray-box");
    if (
      (boardData[currentSquareIndex][0] === 32 && playerTurn === 2) ||
      (boardData[currentSquareIndex][0] === 31 && playerTurn === 1)
    ) {
      x = 4;
      squareRef.current[currentSquareIndex].classList.add("gray-box");
      handleDhamaMoves(
        boardDataRef,
        i,
        j,
        squareRef,
        squareRefPawns,
        boardData,
        setBoardData,
        playerTurn,
        prevSquare,
        setPrevSquare,
        setPlayerTurn
      );
    }
    // ! Player1 move L / R
    else if (
      playerTurn === 1 &&
      boardData[prevSquareIndex][0] === 1 &&
      boardData[currentSquareIndex][0] === 0 &&
      (currentSquareIndex === prevSquareIndex + 9 ||
        currentSquareIndex === prevSquareIndex + 11)
    ) {
      squareRef.current[currentSquareIndex].classList.add("board-square-even");
      squareRefPawns.current[currentSquareIndex].classList.add("red-square");
      boardDataRef.current[prevSquareIndex][0] = 0;
      boardDataRef.current[currentSquareIndex][0] = 1;
      squareRefPawns.current[prevSquareIndex].classList.remove("red-square");
      if (activeSound) {
        new Audio(one).play();
      }

      setPlayerTurn(2);
      changeFromPawnToDhama(
        prevSquareIndex,
        currentSquareIndex,
        boardData,
        setPlayerTurn,
        playerTurn,
        squareRef,
        squareRefPawns,
        boardDataRef,
        dhamaIndex,
        activeSound
      );
      checkMustEat(
        prevSquareIndex,
        currentSquareIndex,
        boardData,
        playerTurn,
        pawnsInTouch
      );
    }
    // ! Player2 move L / R
    else if (
      playerTurn === 2 &&
      boardData[prevSquareIndex][0] === 2 &&
      boardData[currentSquareIndex][0] === 0 &&
      (currentSquareIndex === prevSquareIndex - 9 ||
        currentSquareIndex === prevSquareIndex - 11)
    ) {
      squareRef.current[currentSquareIndex].classList.add("board-square-even");
      squareRefPawns.current[currentSquareIndex].classList.add("blue-square");
      boardDataRef.current[prevSquareIndex][0] = 0;
      boardDataRef.current[currentSquareIndex][0] = 2;
      squareRefPawns.current[prevSquareIndex].classList.remove("blue-square");
      if (activeSound) {
        new Audio(one).play();
      }

      setPlayerTurn(1);
      changeFromPawnToDhama(
        prevSquareIndex,
        currentSquareIndex,
        boardData,
        setPlayerTurn,
        playerTurn,
        squareRef,
        squareRefPawns,
        boardDataRef,
        dhamaIndex,
        activeSound
      );
      checkMustEat(
        prevSquareIndex,
        currentSquareIndex,
        boardData,
        playerTurn,
        pawnsInTouch
      );
    } else if (boardData[currentSquareIndex][0] === 0) {
      // ! player2 logic
      let validMove = false;
      let moves = [];
      if (playerTurn === 2) {
        moves = [
          R1,
          L1,
          R1L3,
          R1L2R1,
          R1L1R1L1,
          R1L1R2,
          R4,
          R3L1,
          R2L2,
          R2L1R1,
          L1R3,
          L1R2L1,
          L1R1L1R1,
          L1R1L2,
          L4,
          L3R1,
          L2R2,
          L2R1L1,
        ];
      } else if (playerTurn === 1) {
        moves = [
          R1_P1,
          L1_P1,
          R1L3_P1,
          R1L2R1_P1,
          R1L1R1L1_P1,
          R1L1R2_P1,
          R4_P1,
          R3L1_P1,
          R2L2_P1,
          R2L1R1_P1,
          L1R3_P1,
          L1R2L1_P1,
          L1R1L1R1_P1,
          L1R1L2_P1,
          L4_P1,
          L3R1_P1,
          L2R2_P1,
          L2R1L1_P1,
        ];
      }

      for (let i = 0; i < moves.length; i++) {
        const move = moves[i];
        if (
          move(
            prevSquareIndex,
            currentSquareIndex,
            boardData,
            setPlayerTurn,
            playerTurn,
            squareRef,
            squareRefPawns,
            setBoardData
          )
        ) {
          validMove = true;
          if (activeSound) {
            new Audio(one).play();
          }
          break;
        }
      }
      setTimeout(() => {
        x = EatMore(
          prevSquareIndex,
          currentSquareIndex,
          boardData,
          setPlayerTurn,
          playerTurn,
          squareRefPawns,
          setBoardData,
          x
        );
        if (validMove) {
          changeFromPawnToDhama(
            prevSquareIndex,
            currentSquareIndex,
            boardData,
            setPlayerTurn,
            playerTurn,
            squareRef,
            squareRefPawns,
            boardDataRef,
            dhamaIndex,
            activeSound
          );
        }
        if (x !== 2) {
          checkMustEat(
            prevSquareIndex,
            currentSquareIndex,
            boardData,
            playerTurn,
            pawnsInTouch
          );
        }
      });
    }
  }
  if (squareColor === 1 || squareColor === 2) {
    squareRef.current[row * 10 + col].classList.add("gray-box");
  }
  if (x === 1) {
    setPrevSquare([row, col]);
  }
}
export default handleSquareClick;
